import React from 'react';
import PropTypes from 'prop-types';

import { FlexRow } from 'ui-components/components/flex';

import { getLocationStringAU } from '../../helpers';
import { useAddressFormContext } from '../../context';
import { PhoneLine } from '../../read-only-fields/phone';
import { EmailLink } from '../../read-only-fields/email';
import { AddressLine } from '../../read-only-fields/address-line';
import { Company } from '../../read-only-fields/company';
import { Name } from '../../read-only-fields/name';

export const AUFields = ({ style }) => {
  const { address, recipientInfo } = useAddressFormContext();
  const { name, company = '', phone = '', line1 = '', line2 = '', line3 = '', city = '', state = '', postalCode = '' } = address;
  const { email } = recipientInfo;
  const australiaLocation = getLocationStringAU(city, state, postalCode);

  return (
    <div className={style}>
      <Name name={name} />
      <Company company={company} />
      <AddressLine line={line1} />
      <AddressLine line={line2} />
      <AddressLine line={line3} />
      {australiaLocation && <FlexRow>{australiaLocation}</FlexRow>}
      <FlexRow>AUSTRALIA</FlexRow>
      <PhoneLine phone={phone} />
      <EmailLink email={email} />
    </div>
  );
};

AUFields.propTypes = {
  style: PropTypes.string,
};
